import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
    token: null,
    password: [],
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
      state.error = null;
      state.password = [];
      localStorage.removeItem("authData");
      localStorage.removeItem("subscriptionData");
      localStorage.removeItem("userId");
      localStorage.removeItem("subscriptionId");
      localStorage.removeItem("receipt_id");
      localStorage.removeItem("seasonId");
      localStorage.removeItem("seriesId");
    },

    registerStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    registerSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },

    registerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateEditUserData: (state, action) => {
      state.loading = true;
      if (action.payload.data?.user) {
        const currentUserData = state.user?.data?.user || {};
        const newUserData = action.payload.data.user;

        state.user = {
          ...state.user,
          data: {
            ...state.user?.data,
            user: {
              ...currentUserData,
              ...newUserData
            }
          }
        };
      } else {
        state.user = { ...state.user, ...action.payload };
      }

      state.loading = false;
    },

    updateFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updatePasswordSuccess: (state, action) => {
      state.loading = false;
      state.password = action.payload;
    },

    updatePasswordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  logout,
  updateEditUserData,
  updateFailure,
  updatePasswordSuccess,
  updatePasswordFailure,
} = authSlice.actions;

export default authSlice.reducer;